import { differenceInCalendarDays, format } from "date-fns";
import type { PersonalAccessToken } from "target_wasm";

const MINUTES_PER_DAY = 1440;
export const DEFAULT_EXPIRATION_TIME = 30 * MINUTES_PER_DAY;
// A token list grows this many rows tall, then scrolls; past it, a search appears.
export const MAX_LIST_ROWS = 5;

/** Whether the Access page for `org` lists this token: the ones bound to it, and, in the
 *  personal org, those minted before tokens had an org. No org yet lists everything. */
export const tokenInOrg = (
  token: PersonalAccessToken,
  org: { org_id: string; is_personal: boolean } | undefined,
): boolean =>
  !org ||
  (token.get_org_id ? token.get_org_id === org.org_id : org.is_personal);

/** Whole local days, so a custom date and the matching preset send the same figure. */
export const minutesUntil = (date: Date): number =>
  differenceInCalendarDays(date, new Date()) * MINUTES_PER_DAY;

export const formatDay = (date: Date): string => format(date, "dd/MM/yyyy");

export const relativeDay = (date: Date): string => {
  const n = differenceInCalendarDays(date, new Date());
  if (n === 0) return "Today";
  if (n === 1) return "Tomorrow";
  if (n === -1) return "Yesterday";
  return n > 0 ? `in ${n} days` : `${-n} days ago`;
};

export const normalizeName = (name: string): string =>
  name.trim().replace(/\s+/g, " ").toLowerCase();
